<template>
  <b-input-group class="input_search">
    <b-dropdown text="All" variant="secondary" slot="prepend" size="sm">
      <b-dropdown-item>Action A</b-dropdown-item>
      <b-dropdown-item>Action B</b-dropdown-item>
    </b-dropdown>
    <span class="search_icon_left">
      <img src="../assets/search.svg" class="search-icon" />
    </span>
    <b-form-input :placeholder="'Search'" />
  </b-input-group>
</template>

<script>
export default {};
</script>

<style scoped>
::placeholder {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #c9c9c9;
}
.input_search {
  width: 415px;
  height: 30px;
}
.search-icon {
  height: 11.5px;
}
.search_icon_left {
  position: absolute;
  z-index: 100;
  left: 94%;
  top: 7px;
}
</style>
